module.exports = __webpack_public_path__ + "img/examination-video-1.729956a5.jpg";